/******/ (() => { // webpackBootstrap
var isDefined = customElements.get('localization-form');

if (!isDefined) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.thing = 0;
      let isScrolling = false;

      this.elements = {
        input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      // Add touchstart, touchmove, and touchend handlers
      this.querySelectorAll('a').forEach((item) => {
        item.addEventListener('touchstart', () => {
          isScrolling = false; // Reset the scrolling flag on touch start
        });

        item.addEventListener(
          'touchmove',
          () => {
            isScrolling = true; // Set the scrolling flag on touch move
          },
          { passive: true } // Use passive listener for better scrolling performance
        );

        item.addEventListener(
          'touchend',
          (event) => {
            if (!isScrolling) {
              event.preventDefault(); // Prevent default behavior only if not scrolling
              this.onItemClick(event);
            }
          },
          { passive: false }
        );

        // Handle click for desktop and non-touch environments
        item.addEventListener('click', (event) => {
          event.preventDefault();
          this.onItemClick(event);
        });
      });
    }


    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      if (event.type === 'touchstart') return;
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = !event.relatedTarget?.classList?.contains('disclosure__item_el');
      if (shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
/******/ })()
;